import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import leadReducer from './slices/leadSlice';
import hrReducer from './slices/hrSlice';
import staffingReducer from './slices/staffingSlice';
import commentReducer from './slices/commentSlice';
import projectReducer from './slices/projectSlice';
import taskReducer from './slices/taskSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    leads: leadReducer,
    hr: hrReducer,
    staffing: staffingReducer,
    comments: commentReducer,
    projects: projectReducer,
    tasks: taskReducer
  }
});
